import { useSelector } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error Untyped module
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
import { getBlogLimitValue, getBlogPostLimitValue, getNumberOfBlogPostsOverLimit, getNumberOfBlogPostsUsed, getNumberOfBlogsOverLimit, getNumberOfBlogsUsed
// @ts-expect-error Untyped module
} from '../redux/selectors/blogLimitsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
function getBlogsDowngradeAlertMessageProps(numBlogPostsOverLimit, numBlogsOverLimit, blogLimit, numBlogsUsed, blogPostLimit, numBlogPostsUsed, blogDashboardUrl) {
  if (numBlogPostsOverLimit > 0 && numBlogsOverLimit > 0) {
    return {
      langKey: numBlogsOverLimit === 1 ? 'limitExceededError.blogAndBlogPosts.oneBlogOverLimit' : 'limitExceededError.blogAndBlogPosts.manyBlogsOverLimit',
      titleMessageOptions: {
        count: blogPostLimit
      },
      messageOptions: {
        count: numBlogPostsOverLimit,
        numBlogsOverLimit,
        blogSettingsUrl: ContentRoutes.settings('blog'),
        blogDashboardUrl
      }
    };
  } else if (numBlogsOverLimit > 0) {
    return {
      langKey: 'limitExceededError.blog',
      titleMessageOptions: {
        count: blogLimit,
        quantityUsed: numBlogsUsed
      },
      messageOptions: {
        count: numBlogsOverLimit,
        blogSettingsUrl: ContentRoutes.settings('blog')
      }
    };
  }
  return {
    langKey: 'limitExceededError.blogPost',
    titleMessageOptions: {
      count: blogPostLimit,
      blogDashboardUrl,
      quantityUsed: numBlogPostsUsed
    },
    messageOptions: {
      count: numBlogPostsOverLimit,
      blogDashboardUrl
    }
  };
}
const LimitExceededError = () => {
  const numBlogPostsOverLimit = useSelector(getNumberOfBlogPostsOverLimit);
  const numBlogsOverLimit = useSelector(getNumberOfBlogsOverLimit);
  const blogLimit = useSelector(getBlogLimitValue);
  const numBlogsUsed = useSelector(getNumberOfBlogsUsed);
  const blogPostLimit = useSelector(getBlogPostLimitValue);
  const numBlogPostsUsed = useSelector(getNumberOfBlogPostsUsed);
  const blogDashboardUrl = useSelector(getDashboardUrl);
  const {
    langKey,
    titleMessageOptions,
    messageOptions
  } = getBlogsDowngradeAlertMessageProps(numBlogPostsOverLimit, numBlogsOverLimit, blogLimit, numBlogsUsed, blogPostLimit, numBlogPostsUsed, blogDashboardUrl);
  return /*#__PURE__*/_jsx(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${langKey}.title`,
      options: titleMessageOptions
    }),
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${langKey}.message`,
      options: messageOptions
    })
  });
};
export default LimitExceededError;